import { stringify } from 'query-string';
import { AXIOS_DEFAULT_OPTIONS } from '..';
import * as constants from '../../constants';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';
import { isEmpty } from 'lodash';
import axios from 'axios';

const initApplication = (dispatch, isLoading = true) =>
dispatch({
  type: constants.AUDIT_LOG_REQUEST,
  isLoading,
});

export const resetApp = () => dispatch => dispatch({ type: constants.APP_RESET });

export const getAuditLogs = ({
  sort,
  page = 0,
  size = 12,
  startTs,
  endTs,
  entityType,
  entityName,
  userName,
  action,
} = {}) =>
  async (dispatch, getState) => {
    initApplication(dispatch);
    resetApp();
    const config = getConfig(getState());
    const { portal } = config;

    const params = stringify({
      sort,
      page,
      size,
      startTs: !isEmpty(startTs) ? startTs : undefined,
      endTs: !isEmpty(endTs) ? endTs : undefined,
      entityType: !isEmpty(entityType) ? entityType : undefined,
      entityName: !isEmpty(entityName) ? entityName : undefined,
      userName: !isEmpty(userName) ? userName : undefined,
      action: !isEmpty(action) ? action : undefined,
    }, true);

    const url = `${portal.hostname}/api/${portal.tenantPrefix}/tenant-admin/1.0/audits?${params}`;
    await axios.get(url, AXIOS_DEFAULT_OPTIONS)
      .then(response =>
        dispatch({
          type: constants.AUDIT_LOG_SUCCESS,
          payload: response.data,
        }),
      )
      .catch((error) =>
        dispatch({
          type: constants.AUDIT_LOG_ERROR,
          error: getValidationErrors(error),
        }),
      );
  };